export const POPUP_ACTION_TYPES = {
  SET_IS_POPUP_OPEN: "popup/SET_IS_POPUP_OPEN",
  SET_POPUP_ALREADY_OPENED: "popup/SET_POPUP_ALREADY_OPENED",
  OPEN_POPUP: "popup/OPEN_POPUP",
};
